import { render, staticRenderFns } from "./CasePresentation.vue?vue&type=template&id=6657161d&scoped=true&"
import script from "./CasePresentation.vue?vue&type=script&lang=js&"
export * from "./CasePresentation.vue?vue&type=script&lang=js&"
import style0 from "./CasePresentation.vue?vue&type=style&index=0&id=6657161d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657161d",
  null
  
)

export default component.exports